import { FacetFilter, FilterName } from "app/search/codecs"
import { array, record, semigroup } from "fp-ts"
import { pipe } from "fp-ts/function"

// ts-prune-ignore-next
export const setParam =
  (k: string) =>
  (v: string) =>
  (x: URLSearchParams): URLSearchParams => {
    const y = new URLSearchParams(x)
    y.set(k, v)

    return y
  }

const _filterToRecord = (arr: FacetFilter[]) =>
  record.fromFoldableMap(semigroup.last<FacetFilter>(), array.array)(arr, (filter) => [
    filter.field,
    filter,
  ])

type UpsertFilterArgs = {
  field: FilterName
  value: string
}

export const upsertFilter =
  ({ field, value }: UpsertFilterArgs) =>
  (filters: FacetFilter[]): FacetFilter[] =>
    pipe(filters, _filterToRecord, record.upsertAt(field, { field, value }), (r) =>
      Object.values(r)
    )

type DeleteFilterArgs = {
  field: FilterName
}

export const deleteFilter =
  ({ field }: DeleteFilterArgs) =>
  (filters: FacetFilter[]): FacetFilter[] =>
    pipe(filters, _filterToRecord, record.deleteAt(field), (r) => Object.values(r))
